import { render, staticRenderFns } from "./reviewInfomation.vue?vue&type=template&id=8cfcc7fa&scoped=true"
import script from "./reviewInfomation.vue?vue&type=script&lang=js"
export * from "./reviewInfomation.vue?vue&type=script&lang=js"
import style0 from "./reviewInfomation.vue?vue&type=style&index=0&id=8cfcc7fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfcc7fa",
  null
  
)

export default component.exports